
import { officialAPIEndpoint } from '@constants/auth';
import { ProviderKey } from '@type/provider';
import { getEnvVar } from '@utils/env';

import { StoreSlice } from './store';

export interface AuthSlice {
  apiKeys: Record<ProviderKey, string>;
  apiEndpoints: Record<ProviderKey, string>;
  firstVisit: boolean;
  setApiKey: (provider: ProviderKey, key: string) => void;
  setApiEndpoint: (provider: ProviderKey, endpoint: string) => void;
  setFirstVisit: (firstVisit: boolean) => void;
}

export const createAuthSlice: StoreSlice<AuthSlice> = (set) => {
  // Log initial values
  const openaiKey = getEnvVar('VITE_OPENAI_API_KEY', '');
  const anthropicKey = getEnvVar('VITE_ANTHROPIC_API_KEY', '');
  const deepinfraKey = getEnvVar('VITE_DEEPINFRA_API_KEY', '');
  console.log('[AuthSlice] Initializing with keys:', {
    openai: openaiKey ? 'present' : 'missing',
    anthropic: anthropicKey ? 'present' : 'missing',
    deepinfra: deepinfraKey ? 'present' : 'missing'
  });
  
  return {
    apiKeys: {
      openai: openaiKey,
      anthropic: anthropicKey,
      deepinfra: deepinfraKey,
    },
    apiEndpoints: {
      openai: officialAPIEndpoint,
      anthropic: 'https://api.anthropic.com/v1/messages',
      deepinfra: '/api/chat/deepinfra',
    },
    firstVisit: true,
    setApiKey: (provider: ProviderKey, key: string) => {
      console.log(`[AuthSlice] Setting API key for ${provider}: ${key ? 'present' : 'missing'}`);
      set((prev) => ({
        ...prev,
        apiKeys: { ...prev.apiKeys, [provider]: key },
      }));
    },
    setApiEndpoint: (provider: ProviderKey, endpoint: string) => {
      set((prev) => ({
        ...prev,
        apiEndpoints: { ...prev.apiEndpoints, [provider]: endpoint },
      }));
    },
    setFirstVisit: (firstVisit: boolean) => {
      set((prev) => ({ ...prev, firstVisit }));
    },
  };
};